import { AssignSupportsCtrl } from './assign-supports.controller';

export const AssignSupportsComponent = {
  controller: AssignSupportsCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./assign-supports.html'),
};
